import {languageReady} from './actions';

export function config(angular) {
  return angular.module('angular-translate-redux', []).run([
    '$translate',
    '$ngRedux',
    function ($translate, $ngRedux) {
      try {
        $translate.onReady(() => $ngRedux.dispatch(languageReady({key: $translate.use()})))
          .catch(e => console.error('Failed to hook into $translate.onReady', e))
      } catch (e) {
        console.error('Failed to hook into $translate.onReady', e)
      }
    }
  ]);
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-translate-redux/src/ngModule.js